import { createContext, useContext } from 'react';

const translations = {
  whatsOnYourMind: "What's on your mind?",
  post: "Post",
  loading: "Loading...",
  noPosts: "No posts yet. Be the first!",
  signInSubtitle: "Sign in to your account",
  signIn: "Sign In",
  noAccount: "No account yet?",
  register: "Register",
  wrongCredentials: "Wrong email or password",
  email: "Email",
  password: "Password",
  joinCommunity: "Join the community",
  createAccount: "Create Account",
  alreadyHaveAccount: "Already have an account?",
  usernameOrEmailExists: "Username or email already exists",
  username: "Username",
  noBio: "No bio yet.",
  posts: "Posts",
  userNotFound: "User not found",
  settings: "Settings",
  settingsTitle: "Settings",
  logout: "Log out",
  back: "Back",
  logoutConfirm: "Are you sure you want to log out?",
  editProfile: "Edit Profile",
  save: "Save",
  displayName: "Display Name",
  displayNameHint: "This is shown instead of your @username",
};

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const t = (key) => translations[key] ?? key;
  return (
    <LanguageContext.Provider value={{ t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
